// 湖南地图数据模块
const state = {
  // 湖南地图数据（含时间维度与线上/线下总码洋）
  hunanMapData: {
    period: 'today',
    totals: { online: 0, offline: 0 },
    regions: [] // [{ cityName, onlineAmount, offlineAmount, totalAmount, ranking }]
  }
}

const mutations = {
  // 设置湖南地图数据
  SET_HUNAN_MAP_DATA(state, data) {
    state.hunanMapData = data
  },
  // 重置湖南地图数据
  RESET_MAP(state) {
    state.hunanMapData = {
      period: 'today',
      totals: { online: 0, offline: 0 },
      regions: []
    }
  }
}

const actions = {
  // 获取湖南地图征订数据（支持静默刷新，从 screenData 派生：按周期合并线上/线下并计算总额与排名）
  async fetchHunanMapData({ commit, rootState }, period = null) {
    try {
      // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
      const currentPeriod = period || state.hunanMapData.period || 'today'
      
      const big = rootState.screen.screenData || {}
      // 选择周期对应的线上/线下数组
      let onlineArr = []
      let offlineArr = []
      switch (currentPeriod) {
        case 'today':
          onlineArr = Array.isArray(big.qudao_ri_xianshang) ? big.qudao_ri_xianshang : []
          offlineArr = Array.isArray(big.qudao_day_xianxia) ? big.qudao_day_xianxia : []
          break
        case 'week':
          onlineArr = Array.isArray(big.qudao_zhou_xianshang) ? big.qudao_zhou_xianshang : []
          offlineArr = Array.isArray(big.qudao_week_xianxia) ? big.qudao_week_xianxia : []
          break
        case 'month':
        default:
          onlineArr = Array.isArray(big.qudao_yue_xianshang) ? big.qudao_yue_xianshang : []
          offlineArr = Array.isArray(big.qudao_yue_xianxia) ? big.qudao_yue_xianxia : []
          break
      }

      const safeNum = (v) => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }
      const nameOf = (item) => String(item?.name || item?.cityName || '').trim()

      // 聚合同名城市线上/线下金额（单位：元），兼容不同字段
      const onlineMap = new Map()
      const offlineMap = new Map()
      let totalOnline = 0
      let totalOffline = 0
      for (const it of onlineArr) {
        const nm = nameOf(it)
        if (!nm) continue
        const val = safeNum(it?.my || it?.sl || it?.salesAmount)
        onlineMap.set(nm, (onlineMap.get(nm) || 0) + val)
        totalOnline += val
      }
      for (const it of offlineArr) {
        const nm = nameOf(it)
        if (!nm) continue
        const val = safeNum(it?.my || it?.sl || it?.salesAmount)
        offlineMap.set(nm, (offlineMap.get(nm) || 0) + val)
        totalOffline += val
      }

      // 城市名全集
      const allNames = new Set([...onlineMap.keys(), ...offlineMap.keys()])
      const regions = Array.from(allNames).map(cityName => {
        const onlineAmount = onlineMap.get(cityName) || 0
        const offlineAmount = offlineMap.get(cityName) || 0
        const totalAmount = onlineAmount + offlineAmount
        return { cityName, onlineAmount, offlineAmount, totalAmount, ranking: 0 }
      })

      // 排名按总额降序
      regions.sort((a, b) => b.totalAmount - a.totalAmount)
      regions.forEach((r, idx) => { r.ranking = idx + 1 })

      commit('SET_HUNAN_MAP_DATA', {
        period: currentPeriod,
        totals: { online: totalOnline, offline: totalOffline },
        regions
      })
    } catch (error) {
      console.error('获取湖南地图征订数据失败:', error)
      commit('SET_HUNAN_MAP_DATA', { period: currentPeriod, totals: { online: 0, offline: 0 }, regions: [] })
    }
  }
}

const getters = {
  currentMapPeriod: state => state.hunanMapData.period,
  hunanMapData: state => state.hunanMapData
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
